import { Outlet } from "react-router-dom";
import Header from "@/components/header";
import Footer from "@/components/footer";
import { useEffect } from "react";
import { clearListingsCache } from "@/hooks/use-listings";

export default function Layout() {
  useEffect(() => {
    clearListingsCache()
  }, [])
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <div className="flex flex-1 flex-col py-8 gap-4 justify-start items-center">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}
